<template>
  <!-- Module -->
  <div class="module" :class="loading ? 'module--loading' : ''">
    <div class="module__media bg-dark-pink"></div>
    <div class="module__header">
      <h2>Search for funding</h2>
    </div>
    <div class="module__main">
      <!-- Search Form -->
      <!-- Search Input -->
      <fieldset>
        <cludo-vue-input
          class="form-control form-control--search"
          placeholder="Search..."
        >
          <span class="sr-only">Search</span>
          <i class="icon-search" aria-hidden="true"></i>
        </cludo-vue-input>
      </fieldset>

      <!-- Collapse Toggle -->
      <button
        type="button"
        class="button button--small button--block button--toggle toggle toggle--m"
        aria-expanded="false"
        aria-controls="search-filters"
        data-toggle="true"
      >
        Filter
        <span v-if="isFiltering" class="badge bg-white">{{
          filtersCount
        }}</span>
      </button>

      <!-- This displays nothing but enables sorting -->
      <SearchSorts
        label="Sort by:"
        :sorts="[
          {
            text: 'Default Name (A-Z)',
            name: 'Title',
            value: 'asc',
            selected: true,
          },
        ]"
      >
      </SearchSorts>

      <!-- Collapse -->
      <div id="search-filters" class="collapse collapse--tablet-expanded">
        <div class="collapse__content">
          <!-- Fee Status  -->
          <cludo-vue-check-boxes
            type="single"
            :options="[
              {
                label: 'All',
                name: 'fee_status_all',
                field: 'fee_status',
                value: '', // keep default blank
                checked: true,
              },
              {
                label: 'Channel Islands and Isle of Man',
                name: 'fee_status_channel_islands_and_isle_of_man',
                field: 'fee_status',
                value: 'Channel Islands and Isle of Man',
              },
              {
                label: 'EU',
                name: 'fee_status_eu',
                field: 'fee_status',
                value: 'EU',
              },
              {
                label: 'International',
                name: 'fee_status_international',
                field: 'fee_status',
                value: 'International',
              },
              {
                label: 'UK',
                name: 'fee_status_uk',
                field: 'fee_status',
                value: 'UK',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Fee status</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Study Stage  -->
          <cludo-vue-check-boxes
            type="single"
            :options="[
              {
                label: 'All',
                name: 'study_stage_all',
                field: 'study_stage',
                value: '', // keep default blank
                checked: true,
              },
              {
                label: 'Alumni',
                name: 'study_stage_alumni',
                field: 'study_stage',
                value: 'Alumni',
              },
              {
                label: 'Applicant',
                name: 'study_stage_applicant',
                field: 'study_stage',
                value: 'Applicant',
              },
              {
                label: 'Current',
                name: 'study_stage_current',
                field: 'study_stage',
                value: 'Current',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Study Stage</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Study Level  -->
          <cludo-vue-check-boxes
            type="single"
            :options="[
              {
                label: 'All',
                name: 'study_level_all',
                field: 'study_level',
                value: '', // keep default blank
                checked: true,
              },
              {
                label: 'Continuing Professional Development',
                name: 'study_level_continuing_professional_development',
                field: 'study_level',
                value: 'Continuing Professional Development',
              },
              {
                label: 'Foundation',
                name: 'study_level_foundation',
                field: 'study_level',
                value: 'Foundation',
              },
              {
                label: 'Postgraduate research',
                name: 'study_level_postgraduate_research',
                field: 'study_level',
                value: 'Postgraduate research',
              },
              {
                label: 'Postgraduate taught',
                name: 'study_level_postgraduate_taught',
                field: 'study_level',
                value: 'Postgraduate taught',
              },
              {
                label: 'Undergraduate',
                name: 'study_level_undergraduate',
                field: 'study_level',
                value: 'Undergraduate',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Study Level</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Study Mode  -->
          <cludo-vue-check-boxes
            type="single"
            :options="[
              {
                label: 'All',
                name: 'study_mode_all',
                field: 'study_mode',
                value: '', // keep default blank
                checked: true,
              },
              {
                label: 'Full-time',
                name: 'study_mode_full_time',
                field: 'study_mode',
                value: 'Full-time',
              },
              {
                label: 'Part-time',
                name: 'study_mode_part_time',
                field: 'study_mode',
                value: 'Part-time',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Study Stage</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Funding Category  -->
          <cludo-vue-check-boxes
            type="single"
            :options="[
              {
                label: 'All',
                name: 'funding_category_all',
                field: 'funding_category',
                value: '', // keep default blank
                checked: true,
              },
              {
                label: 'Accommodation',
                name: 'funding_category_accommodation',
                field: 'funding_category',
                value: 'Accommodation',
              },
              {
                label: 'Community & engagement',
                name: 'funding_category_community_and_engagement',
                field: 'funding_category',
                value: 'Community & engagement',
              },
              {
                label: 'Financial support',
                name: 'funding_category_financial_support',
                field: 'funding_category',
                value: 'Financial support',
              },
              {
                label: 'Graduation',
                name: 'funding_category_graduation',
                field: 'funding_category',
                value: 'Graduation',
              },
              {
                label: 'Living costs',
                name: 'funding_category_living_costs',
                field: 'funding_category',
                value: 'Living costs',
              },
              {
                label: 'Music',
                name: 'funding_category_music',
                field: 'funding_category',
                value: 'Music',
              },
              {
                label: 'Sport',
                name: 'funding_category_sport',
                field: 'funding_category',
                value: 'Sport',
              },
              {
                label: 'Travel',
                name: 'funding_category_travel',
                field: 'funding_category',
                value: 'Travel',
              },
              {
                label: 'Tuition fees',
                name: 'funding_category_tuition_fees',
                field: 'funding_category',
                value: 'Tuition fees',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Funding category</legend>
            </div>
          </cludo-vue-check-boxes>

          <!-- Location Specific Category  -->
          <SelectOptions
            type="single"
            :options="[
              {
                label: 'All',
                name: 'country_all',
                field: 'country',
                value: '',
                checked: true,
              },
              {
                label: 'China',
                name: 'country_china',
                field: 'country',
                value: 'China',
              },
              {
                label: 'Colombia',
                name: 'country_colombia',
                field: 'country',
                value: 'Colombia',
              },
              {
                label: 'Commonwealth',
                name: 'country_commonwealth',
                field: 'country',
                value: 'Commonwealth',
              },
              {
                label: 'Hong Kong',
                name: 'country_hong_kong',
                field: 'country',
                value: 'Hong Kong',
              },
              {
                label: 'India',
                name: 'country_india',
                field: 'country',
                value: 'India',
              },
              {
                label: 'United States',
                name: 'country_united_states',
                field: 'country',
                value: 'United States',
              },
              {
                label: 'Vietnam',
                name: 'country_vietnam',
                field: 'country',
                value: 'Vietnam',
              },
            ]"
          >
            <div class="filter-heading">
              <legend>Location-specific</legend>
            </div>
          </SelectOptions>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectOptions from "./SelectOptions.vue";
import SearchSorts from "./SearchSorts.vue";
export default {
  components: { SelectOptions, SearchSorts },
  props: {
    filterParamaters: {
      type: Object,
      default: () => {},
    },
    isFiltering: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filtersCount() {
      const searchFilterCount =
        this.filterParamaters?.searchFilter?.length ?? 0;
      const sortFilterCount = this.filterParamaters?.sortFilter?.length ?? 0;
      const rangeFilterCount =
        Object.keys(this.filterParamaters?.rangeFilter)?.length ?? 0;

      const validCheckboxesFilterCount =
        this.filterParamaters?.checkboxFilter.filter(
          (el) => el.checked === true && el.value !== ""
        ).length ?? 0;

      const count =
        searchFilterCount +
        sortFilterCount +
        rangeFilterCount +
        validCheckboxesFilterCount;
      return count - 1;
    },
  },
};
</script>

<style lang="scss">
.module {
  &__main {
    fieldset {
      padding: 0;
      border: none;
      width: 100%;
    }
    .form-control--input {
      input,
      label {
        cursor: pointer;
      }
    }
  }
}
.badge {
  margin-left: 0.75rem !important;
}
</style>
